import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModalDialogNotificationService, NotificationType } from './notification.service';
import { ButtonClick } from '../dialogs/se-modalwindow/se-modalwindow.component';


@Injectable({
    providedIn: 'root',
})
export class CanPageDeactiveDialogService {

    // constructor

    constructor(private modalDialogNotificationService: ModalDialogNotificationService) {
    }

    // public functions

    confirmYesNo(message: string, title: string): Observable<boolean> {

        return this.modalDialogNotificationService.notify({
            message: message,
            title: title,
            type: NotificationType.warning,
            buttonYes: true,
            buttonNo: true,
            buttonOk: false,
            buttonCancel: false
        })
            .pipe(map((button) => {

                if (button != ButtonClick.yes)
                    return false;

                return true;
            }));
    }

    confirmOkCancel(message: string, title: string): Observable<boolean> {

        return this.modalDialogNotificationService.notify({
            message: message,
            title: title,
            type: NotificationType.warning,
            buttonYes: false,
            buttonNo: false,
            buttonOk: true,
            buttonCancel: true
        })
            .pipe(map((button) => {

                if (button != ButtonClick.ok)
                    return false;

                return true;
            }));
    }
}
